import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBlackFridayBanner } from '../../components/NewbuildingBlackFridayBanner';
import { getNewbuildingBlackFridayUrl } from '../../selectors/newbuildingBlackFriday';

export function NewbuildingBlackFridayBannerContainer() {
  const url = useSelector(getNewbuildingBlackFridayUrl);

  return <NewbuildingBlackFridayBanner url={url} />;
}
